"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { captureUtmFromSearch } from "@/lib/analytics/utm";

/** Сохраняет utm_* из URL при навигации (для заявок в CRM). */
export function UtmCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const search = searchParams.toString();
    if (!search) return;
    captureUtmFromSearch(`?${search}`);
  }, [pathname, searchParams]);

  return null;
}
